import { propertySourceType, syncType } from 'common/constants/property';

export const getSyncType = externalSystem => {
  if (externalSystem === propertySourceType.PUBLIC_GATEWAY) {
    return syncType.OPEN_API;
  }

  if (
    [
      propertySourceType.INTEGRATION,
      propertySourceType.SALESFORCE,
      propertySourceType.ENTRATA,
    ].includes(externalSystem)
  ) {
    return syncType.INTEGRATION;
  }

  return null;
};
